// SPDX-License-Identifier: AGPL-3.0-or-later

// LOCAL-ONLY (favorites-bookmarks-plan.md section 10): the fork's reconnect list. The gateway's router takes one
// handler per event, so RESUMED's handler runs every handler registered here, in the order registered. A fork feature
// registers from its own module: the calendar (CalendarGateway.ts) and the favorites previews (FavoritePreviews.ts),
// both loaded by EventRouter.ts. Exclude from upstream sync.

type ReconnectHandler = () => void;

const handlers: Array<ReconnectHandler> = [];

export function registerReconnectHandler(handler: ReconnectHandler): void {
	handlers.push(handler);
}

export function handleResumed(): void {
	for (const handler of handlers) handler();
}
